import { useState } from 'react';

const MODALIDADES = [
  {
    id: 'futbol5',
    label: 'Fútbol 5',
    icono: '⚽',
    desc: 'Árbitro único · cancha pequeña',
    opciones: [],
  },
  {
    id: 'futbol7',
    label: 'Fútbol 7',
    icono: '⚽',
    desc: 'Árbitro único · formato más popular',
    opciones: [],
  },
  {
    id: 'futbol11',
    label: 'Fútbol 11',
    icono: '⚽',
    desc: 'Cancha reglamentaria',
    opciones: [
      { id: 'gl1', label: '+ 1 guardalíneas' },
      { id: 'gl2', label: '+ 2 guardalíneas' },
    ],
  },
];

export default function StepModalidadesArbitro({ datos, onNext, onBack }) {
  const [seleccionadas, setSeleccionadas] = useState(
    datos.modalidades || []
  );
  const [opcionesExtra, setOpcionesExtra] = useState(
    datos.opcionesExtra || {}
  );
  const [error, setError] = useState('');

  const toggleModalidad = (id) => {
    setSeleccionadas(prev =>
      prev.includes(id)
        ? prev.filter(m => m !== id)
        : [...prev, id]
    );
    setError('');
  };

  const toggleOpcion = (modalidadId, opcionId) => {
    setOpcionesExtra(prev => ({
      ...prev,
      [modalidadId]: prev[modalidadId] === opcionId ? null : opcionId,
    }));
  };

  const handleNext = () => {
    if (seleccionadas.length === 0) {
      setError('Selecciona al menos una modalidad');
      return;
    }
    onNext({ modalidades: seleccionadas, opcionesExtra });
  };

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Modalidades que arbitras</h2>
      <p style={styles.sub}>
        Selecciona los formatos en que tienes experiencia.
        Para Fútbol 11 puedes ofrecer guardalíneas adicionales.
      </p>

      <div style={styles.lista}>
        {MODALIDADES.map(({ id, label, icono, desc, opciones }) => {
          const activo = seleccionadas.includes(id);
          return (
            <div key={id}>
              <div
                onClick={() => toggleModalidad(id)}
                style={{
                  ...styles.card,
                  border: `2px solid ${activo ? '#1A6BFF' : '#E8ECF4'}`,
                  background: activo ? '#EFF5FF' : 'white',
                }}
              >
                <div style={styles.cardIcono}>{icono}</div>
                <div style={styles.cardInfo}>
                  <div style={styles.cardLabel}>{label}</div>
                  <div style={styles.cardDesc}>{desc}</div>
                </div>
                {activo && <div style={styles.check}>✓</div>}
              </div>

              {/* Opciones extra para Fútbol 11 */}
              {activo && opciones.length > 0 && (
                <div style={styles.opcionesWrap}>
                  <div style={styles.opcionesLabel}>
                    Opciones adicionales para {label}:
                  </div>
                  <div style={styles.opcionesRow}>
                    {opciones.map(({ id: opId, label: opLabel }) => {
                      const seleccionada = opcionesExtra[id] === opId;
                      return (
                        <div
                          key={opId}
                          onClick={() => toggleOpcion(id, opId)}
                          style={{
                            ...styles.opcionChip,
                            background: seleccionada ? '#1A6BFF' : '#F4F6FA',
                            color:      seleccionada ? 'white'   : '#4A5568',
                            border:     `1.5px solid ${seleccionada ? '#1A6BFF' : '#E8ECF4'}`,
                          }}
                        >
                          {opLabel}
                        </div>
                      );
                    })}
                    <div
                      onClick={() => toggleOpcion(id, null)}
                      style={{
                        ...styles.opcionChip,
                        background: !opcionesExtra[id] ? '#1A6BFF' : '#F4F6FA',
                        color:      !opcionesExtra[id] ? 'white'   : '#4A5568',
                        border:     `1.5px solid ${!opcionesExtra[id] ? '#1A6BFF' : '#E8ECF4'}`,
                      }}
                    >
                      Solo árbitro
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div style={styles.notaPadel}>
        🎾 Pádel no requiere árbitro — no está incluido en el listado
      </div>

      {error && <p style={styles.error}>{error}</p>}

      <div style={styles.botones}>
        <button style={styles.btnBack} onClick={onBack}>← Atrás</button>
        <button style={styles.btnNext} onClick={handleNext}>Siguiente →</button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 20, lineHeight: 1.5,
  },
  lista: { display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 16 },
  card: {
    display: 'flex', alignItems: 'center', gap: 14,
    borderRadius: 12, padding: '14px 16px',
    cursor: 'pointer', transition: 'all 0.12s',
    position: 'relative',
  },
  cardIcono: { fontSize: 24, flexShrink: 0 },
  cardInfo:  { flex: 1 },
  cardLabel: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 700, color: '#141922', marginBottom: 2,
  },
  cardDesc: {
    fontSize: 12, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
  },
  check: {
    background: '#1A6BFF', color: 'white',
    width: 22, height: 22, borderRadius: '50%',
    display: 'flex', alignItems: 'center',
    justifyContent: 'center', fontSize: 11, fontWeight: 700,
    flexShrink: 0,
  },
  opcionesWrap: {
    background: '#F4F6FA', borderRadius: '0 0 12px 12px',
    padding: '10px 16px', marginTop: -4, marginBottom: 4,
  },
  opcionesLabel: {
    fontSize: 11, fontWeight: 700, color: '#9BA5B7',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    fontFamily: "'Barlow', sans-serif", marginBottom: 8,
  },
  opcionesRow: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  opcionChip: {
    padding: '6px 14px', borderRadius: 20,
    fontSize: 12, fontWeight: 600,
    cursor: 'pointer', transition: 'all 0.12s',
    fontFamily: "'Barlow', sans-serif",
  },
  notaPadel: {
    fontSize: 12, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
    background: '#F4F6FA', borderRadius: 10,
    padding: '10px 14px', marginBottom: 16,
  },
  error: {
    color: '#EF4444', fontSize: 12,
    fontFamily: "'Barlow', sans-serif", marginBottom: 12,
  },
  botones: { display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10 },
  btnBack: {
    padding: '13px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 12,
    fontSize: 14, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnNext: {
    padding: '13px', background: '#FF6B1A', border: 'none',
    borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800, color: 'white', cursor: 'pointer',
  },
};